var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyInbox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12727",
    "data-name": "Group 12727",
    transform: "translate(-889.615 -296.241)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 111,
    height: 111,
    rx: 13,
    transform: "translate(889.615 296.241)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9612",
    "data-name": "Path 9612",
    d: "M26.244-19.134,16.336-34a5.027,5.027,0,0,0-3.744-2H-12.592a5.027,5.027,0,0,0-3.744,2l-9.908,14.863a5.283,5.283,0,0,0-.756,2.5h0V-4.5A4.5,4.5,0,0,0-22.5,0h45A4.5,4.5,0,0,0,27-4.5V-16.637h0A5.283,5.283,0,0,0,26.244-19.134ZM-11.789-30H11.789l8,12H8.25l-3,6H-5.25l-3-6H-19.789Z",
    transform: "translate(945.615 370.241)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInbox);
export default __webpack_public_path__ + "static/media/empty_inbox.79be376525b63f183173ca5dc7e55f57.svg";
export { ForwardRef as ReactComponent };